'use strict';

(() => {
  const LINE_ACCOUNT_ID = '@471pnfuc';
  const RING_SIZE_OPTION_NAMES = ['リングサイズ', 'サイズ'];

  function getSelectedSize() {
    const variantPicker = document.querySelector('variant-picker[data-template-product-match="true"]');
    if (!variantPicker) return '';

    for (const optionName of RING_SIZE_OPTION_NAMES) {
      const select = variantPicker.querySelector(`select[name="options[${optionName}]"]`);
      if (select instanceof HTMLSelectElement && select.value) return select.value;

      const legends = variantPicker.querySelectorAll('fieldset.variant-option legend');
      for (const legend of legends) {
        if (!legend.textContent.trim().startsWith(optionName)) continue;

        const checked = legend.closest('fieldset')?.querySelector('input:checked');
        if (checked instanceof HTMLInputElement && checked.value) return checked.value;
      }
    }

    return '';
  }

  function formatSelectedSize(size) {
    if (!size || !/^\d+(?:\.\d+)?$/.test(size)) return size;
    return `${size}号`;
  }

  function init(container) {
    const trigger = container.querySelector('[data-hrd-line-friend-inquiry-trigger]');
    const dialog = container.querySelector('[data-hrd-line-friend-inquiry-dialog]');
    const fields = container.querySelector('[data-hrd-line-friend-inquiry-fields]');
    const loanFields = container.querySelector('[data-hrd-line-friend-inquiry-loan]');
    const preview = container.querySelector('[data-hrd-line-friend-inquiry-preview]');
    const confirmButton = container.querySelector('[data-hrd-line-friend-inquiry-confirm]');
    const cancelButtons = container.querySelectorAll('[data-hrd-line-friend-inquiry-cancel]');

    if (
      !(trigger instanceof HTMLButtonElement) ||
      !(dialog instanceof HTMLDialogElement) ||
      !(fields instanceof HTMLElement) ||
      !(loanFields instanceof HTMLDetailsElement) ||
      !(preview instanceof HTMLElement) ||
      !(confirmButton instanceof HTMLButtonElement)
    ) {
      return;
    }

    const getField = (name) => fields.querySelector(`[data-field="${name}"]`);
    const getValue = (name) => {
      const field = getField(name);
      return field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement ? field.value.trim() : '';
    };
    const setValue = (name, value) => {
      const field = getField(name);
      if (field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement) field.value = value;
    };

    let lastAutoFilledSize = '';
    let bodyOverflow = '';

    const createMessage = () => {
      const sections = [];
      const inquiry = getValue('inquiry');
      const productName = getValue('productName');
      const pageUrl = getValue('pageUrl');
      const desiredSize = getValue('desiredSize');

      if (inquiry) sections.push(`■お問い合わせ内容：\n${inquiry}`);
      if (productName) sections.push(`■商品名：${productName}`);
      if (pageUrl) sections.push(`■URL：${pageUrl}`);
      if (desiredSize) sections.push(`■ご希望サイズ：${desiredSize}`);

      if (loanFields.open) {
        const loanValues = [
          ['お名前（漢字・フルネーム）', getValue('loanName')],
          ['フリガナ', getValue('loanKana')],
          ['メールアドレス', getValue('loanEmail')],
          ['お電話番号', getValue('loanPhone')],
        ].filter(([, value]) => value);

        if (loanValues.length) {
          sections.push(`【ショッピングローン情報】\n${loanValues.map(([label, value]) => `■${label}：${value}`).join('\n')}`);
        }
      }

      return sections.join('\n\n');
    };

    const updatePreview = () => {
      preview.textContent = createMessage();
    };

    const setSelectedSize = () => {
      const selectedSize = formatSelectedSize(getSelectedSize());
      const sizeField = getField('desiredSize');
      if (!(sizeField instanceof HTMLInputElement)) return;

      if (!sizeField.value || sizeField.value === lastAutoFilledSize) {
        sizeField.value = selectedSize;
        lastAutoFilledSize = selectedSize;
        updatePreview();
      }
    };

    const openDialog = () => {
      setValue('productName', container.dataset.productName || '');
      setValue('pageUrl', container.dataset.pageUrl || window.location.href);
      setValue('desiredSize', formatSelectedSize(getSelectedSize()));
      lastAutoFilledSize = getValue('desiredSize');
      updatePreview();

      bodyOverflow = document.body.style.overflow;
      document.body.classList.add('hrd-line-friend-inquiry--modal-open');
      dialog.showModal();
      getField('inquiry')?.focus();
    };

    trigger.addEventListener('click', openDialog);
    fields.addEventListener('input', updatePreview);
    loanFields.addEventListener('toggle', updatePreview);

    cancelButtons.forEach((button) => {
      button.addEventListener('click', () => dialog.close());
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      document.body.classList.remove('hrd-line-friend-inquiry--modal-open');
      document.body.style.overflow = bodyOverflow;
    });

    confirmButton.addEventListener('click', () => {
      const message = createMessage();
      const lineUrl = `https://line.me/R/oaMessage/${encodeURIComponent(LINE_ACCOUNT_ID)}/?${encodeURIComponent(message)}`;
      window.location.assign(lineUrl);
    });

    document.addEventListener('variant:selected', () => {
      if (dialog.open) setSelectedSize();
    });
  }

  function initialize() {
    document.querySelectorAll('[data-hrd-line-friend-inquiry]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
